import React, { Fragment } from 'react';
import PageTitle from '../../components/pagetitle/PageTitle'
import Contactpage from '../../components/Contactpage/Contactpage'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';
import Navbar from '../../components/Navbar/Navbar';
import Navbar2 from '../../components/Navbar2/Navbar2'
import Logo from '../../images/logo2.png'

const ContactPage = () => {
    return (
        <Fragment>
            <Navbar2 hclass={'wpo-header-style-1'} Logo={Logo} />
            <PageTitle pageTitle={'Bize Ulaşın'} pagesub={'İletişim'} />
            <Contactpage />
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default ContactPage;

